import React from "react";
import { motion } from "framer-motion";
import { useI18n } from "@/i18n/I18nContext";

export default function LangToggle({ variant = "light" }) {
  const { locale, setLocale, t } = useI18n();
  const next = locale === "en" ? "sw" : "en";

  const isLight = variant === "light";

  return (
    <button
      onClick={() => setLocale(next)}
      className={`relative inline-flex items-center gap-1.5 rounded-full text-[11px] font-mono-caption tracking-[0.14em] uppercase px-3 py-1.5 transition-colors ${
        isLight
          ? "text-[var(--ink-2)]/70 hover:text-[var(--ink)] bg-[var(--cream-2)] hover:bg-[var(--cream-2)]/80 border border-[rgba(15,31,23,0.08)]"
          : "text-[var(--cream)]/80 hover:text-[var(--cream)] bg-[rgba(253,251,247,0.06)] hover:bg-[rgba(253,251,247,0.12)] border border-[rgba(253,251,247,0.15)]"
      }`}
      data-testid="lang-toggle"
      aria-label={`Switch language to ${t.lang.switch_to}`}
    >
      <svg width="12" height="12" viewBox="0 0 24 24" fill="none" aria-hidden>
        <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.6" />
        <path
          d="M3 12h18M12 3c3 3 4.5 6 4.5 9S15 21 12 21s-4.5-3-4.5-9S9 3 12 3z"
          stroke="currentColor"
          strokeWidth="1.6"
          fill="none"
        />
      </svg>
      <span className="flex items-center gap-1">
        <motion.span
          key={locale}
          initial={{ opacity: 0, y: -3 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.25 }}
        >
          {locale === "en" ? "EN" : "SW"}
        </motion.span>
        <span className={isLight ? "text-[var(--ink-2)]/30" : "text-[var(--cream)]/40"}>/</span>
        <span className={isLight ? "text-[var(--ink-2)]/40" : "text-[var(--cream)]/50"}>
          {locale === "en" ? "SW" : "EN"}
        </span>
      </span>
    </button>
  );
}
